import React from "react";

import type { DeepDiveSection } from "@app/analytics/MeetingReport/types";

import DeepDiveHighlights from "./DeepDiveHighlights";
import DeepDiveParticipation from "./DeepDiveParticipation";
import DeepDiveStandings from "./DeepDiveStandings";

const TabbedDeepDiveContent = ({
  selectedSection,
}: {
  selectedSection: DeepDiveSection;
}) => {
  switch (selectedSection) {
    case "standings":
      return <DeepDiveStandings />;
    case "highlights":
      return <DeepDiveHighlights />;
    case "participation":
    default:
      return <DeepDiveParticipation />;
  }
};

export default TabbedDeepDiveContent;
